import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';
import { Paper, Typography, Skeleton, Box } from '@mui/material';
import { formatMoney } from '../../../utils/currency';

const CustomTooltip = ({ active, payload, label, branchesMap }) => {
  if (!active || !payload?.length) return null;

  const date = payload[0].payload.date;
  const total = payload.reduce((sum, entry) => sum + entry.value, 0);

  return (
    <Box p={1} bgcolor="white" boxShadow={2} borderRadius={1}>
      <Typography variant="subtitle2">📅 Fecha: {date}</Typography>
      <Typography variant="body2" fontWeight="bold">
        💰 Total: {formatMoney(total)}
      </Typography>
      {payload.map((entry) => {
        const branch = branchesMap[entry.dataKey];
        return (
          <Typography key={entry.dataKey} variant="body2" sx={{ color: entry.color }}>
            {branch ? (branch.deleted ? `${branch.name} (eliminada)` : branch.name) : entry.dataKey}: {formatMoney(entry.value)}
          </Typography>
        );
      })}
    </Box>
  );
};

const SalesTrendChartStacked = ({ data = [], loading, branches = [] }) => {
  const transformedData = data.map(entry => ({
    display: entry.display,
    date: entry.date,
    ...entry.sales,
  }));

  const branchesMap = Object.fromEntries(branches.map((b) => [b.id, b]));

  return (
    <Paper elevation={2} sx={{ p: 2, height: 360 }}>
      <Typography variant="subtitle1" gutterBottom>
        Ventas diarias
      </Typography>

      <Box sx={{ width: '100%', height: 300 }}>
        {loading ? (
          <Skeleton variant="rectangular" width="100%" height={300} />
        ) : transformedData.length > 0 && branches.length > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={transformedData} margin={{ top: 20, right: 20, bottom: 0, left: 0 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="display" />
              <YAxis />
              <Tooltip content={<CustomTooltip branchesMap={branchesMap} />} />
              <Legend />
              {branches.map(({ id, name, color, deleted }) => (
                <Bar
                  key={id}
                  dataKey={String(id)}
                  stackId="total"
                  fill={color}
                  fillOpacity={deleted ? 0.4 : 1}
                  name={deleted ? `${name} (eliminada)` : name}
                />
              ))}
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2" color="textSecondary">
              No hay datos disponibles.
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default SalesTrendChartStacked;
